import Recipe from '~/components/Recipe.vue'
export const recipeCustom = {
  components: { Recipe },
  props: {
    recipeName: {
      type: String,
      default: ''
    },
    prePack: {
      type: String,
      default: ''
    },
    postPack: {
      type: String,
      default: ''
    }
  }
}
